const API_URL = "https://royalstars.miniapps.tech/api";

export async function logUser(user) {
    return fetch(`${API_URL}/users`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            tgId: user.id,
            is_bot: user.is_bot,
            first_name: user.first_name,
            last_name: user.last_name,
            username: user.username,
            language_code: user.language_code,
            is_premium: user.is_premium,
            allows_write_to_pm: user.allows_write_to_pm,
            start_param: user.start_param,
            action: "open_app"
        })
    }).then(res => res.json());
}

